// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3-yCC","label":"Completed_label__2HXO8"};